/**
 * 从 Telegram 服务号消息中提取登录验证码（只返回验证码数字）。
 * 优先匹配多语言关键词后的数字，兜底取首个 5-6 位独立数字。
 */
export function extractLoginCode(text: string): string | undefined {
  if(!text) return undefined;
  const keywordMatch = text.match(/(?:login code|code|验证码|驗證碼|验证代码|登录代码|登入代碼|代码|代碼|код|رمز)[\s:：-]*(\d{4,7})/i);
  if(keywordMatch) return keywordMatch[1];
  const fallbackMatch = text.match(/\b\d{5,6}\b/);
  return fallbackMatch ? fallbackMatch[0] : undefined;
}
